import { render, staticRenderFns } from "./productReviews.vue?vue&type=template&id=0e25ee54"
import script from "./productReviews.vue?vue&type=script&lang=js"
export * from "./productReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports